import { MprcFeedTypography } from "components/MprcFeedTypography";
import { useTranslation } from "react-i18next";
import { useCardContext } from "views/knowledge/components/card/CardBuilder";

export const ContentHidden = () => {
    const {
        pub: { interaction: { isVisible } },
    } = useCardContext();
    const { t } = useTranslation("knowledge");

    return !isVisible
        ? (
            <>
                <MprcFeedTypography variant="content" component="div">
                    <span>{t("Feed.Card.Common.ContentHiddenText")}</span>
                </MprcFeedTypography>
            </>
        )
        : null;
};
